



































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'PayoutBankAccountResourceList'

  vue:
    props: ['payoutBankAccounts', 'infiniteWrapper', 'options', 'actions']

    components: {
      ResourceList,
      LoadingIndicator,
    }

    data: ->
      pageNumber: 1

    computed:
      components: ->
        'payout-bank-account-resource-list-item': () => import('./PayoutBankAccountResourceListItem')

      title: ->
        @options?.title || 'Payout Bank Accounts'

      resourceKey: ->
        @options?.resourceKey || 'payout_bank_accounts'

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, {}, { page: @pageNumber })
        @pageNumber += 1

export default VueOptions.vue settings
